/* Day One Threads: open a print's product page with a style already chosen.
   A link like /products/<print>?style=Twirl%20Dress picks "Twirl Dress" in the Style dropdown,
   exactly as if the customer had chosen it, so the existing picker, add-ons and cart behave as
   usual. It does nothing when the link already names a variant (?variant=), when a style is
   already showing, or when the style isn't offered on that print. */
(function () {
  const params = new URLSearchParams(window.location.search);
  const wanted = (params.get('style') || '').trim();
  if (!wanted || params.has('variant')) return;
  if (wanted.toLowerCase() === 'matching dolly gown') return;

  function choose() {
    const picker = document.querySelector('variant-selects.dot-picker[data-picker-state="empty"]');
    if (!picker) return;
    const select = picker.querySelector('[data-option-position="1"] select');
    if (!select) return;
    const option = Array.from(select.options).find(
      (o) => o.value && o.value.toLowerCase() === wanted.toLowerCase()
    );
    if (!option) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function start() {
    customElements.whenDefined('variant-selects').then(() => window.setTimeout(choose, 0));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
